import { useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import AwesomeError from 'components/Common/AwesomeError'
import BodyText from 'LuxKit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'

/** @deprecated */
function CalendarRecommendationsNotAvailableMessage() {
  const intl = useIntl()
  const contact = useContext(ContactContext)
  return (
    <AwesomeError title={intl.formatMessage({
      id: 'qxs4IdT0V0xeK7mgSx1p',
      defaultMessage: 'No offers found for the dates you requested.',
      description: 'Error title when no calendar recommendations are found',
    })}
    >
      <BodyText variant="large" colour="normal-contrast">
        <FormattedMessage
          id="UkeYCDERkjgBWjv5fYBy"
          defaultMessage="But we probably have something for you.{br}<phoneLink>{phoneNumber}</phoneLink>."
          description="Body text encouraging users to call support when no calendar recommendations are available"
          values={{
            br: <br />,
            phoneNumber: contact.defaultContact.humanReadable,
            phoneLink: (chunks) => <a href={`tel:${contact.defaultContact.number}`} rel="nofollow">{chunks}</a>,
          }}
        />
      </BodyText>
    </AwesomeError>
  )
}

export default CalendarRecommendationsNotAvailableMessage
